import CustomPagination from "../../../../components/ui/CustomPagination";
import Loader from "../../../../components/ui/Loader";
import { useGetOfficeSettingLogQuery } from "../../../../features/attendanceSetting/attendanceSettingApi";
import useError from "../../../../hooks/useError";
import useTable from "../../../../hooks/useTable";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { formatDate, formatTime } from "../../../../lib/time";
import { officeSettingsTabList } from "./officeSettingsTabList";

export default function ChangeLog() {
  const { filter, page, handlePagination } = useTable<{
    page: number;
    limit: number;
    skip: number;
  }>();
  const { data, error, isError, isLoading } =
    useGetOfficeSettingLogQuery(filter);
  const logData = data?.data?.officeSettingChangeLog;

  useError(isError, error, "Log data get fail");

  return (
    <SidebarLayout title="Office Settings" tabList={officeSettingsTabList}>
      <div className="bg-white p-6 rounded-lg">
        <h2 className="text-lg font-semibold text-[#2D3643] text-[22px] mb-4">
          Change Log
        </h2>

        {isLoading ? (
          <Loader />
        ) : (
          <>
            <div className="">
              {logData?.map((val, index) => (
                <div key={index} className="relative pl-6 pb-4">
                  {logData?.length - 1 === index ? null : (
                    <div className="absolute left-[4px] bottom-0 w-[2px] h-full rounded-full bg-[#D7DFE9]"></div>
                  )}
                  <div className="absolute left-0 top-0.5 w-2.5 h-2.5 rounded-full bg-[#1DB469]"></div>

                  <div className="flex items-center space-x-3">
                    <span className="bg-gray-100 text-gray-700 text-xs font-medium px-2 py-1 text-[#5E718D] bg-[#F0F3F9] rounded capitalize">
                      {val?.type}
                    </span>
                    <span className="text-[#C19C60] text-sm font-medium">
                      {formatTime(val?.created_at)} -{" "}
                      {formatDate(val?.created_at)}
                    </span>
                  </div>

                  <p
                    className={`text-sm text-[#455468] mt-1 pb-4 ${
                      index !== logData?.length - 1 &&
                      "border-b border-[#E9EFF6]"
                    }`}
                  >
                    {val?.logs} – by{" "}
                    <span className="text-[#4A72FF] font-medium ">
                      {val?.created_by_name}
                    </span>
                  </p>
                </div>
              ))}
            </div>

            <CustomPagination
              total={data?.data?.total || 0}
              limit={filter?.limit}
              page={page}
              handlePagination={handlePagination}
            />
          </>
        )}
      </div>
    </SidebarLayout>
  );
}
